/* eslint-disable @typescript-eslint/no-explicit-any */
import { PaginationData, QueryParams } from 'shared/types';
import { FacturationType, Product, ProductType, ProductTypeUnit } from '../models';
import { productRequester as request } from './requesters';
import ProductTypeIntervention from 'features/products/models/product-type-interventions.model';
import { WasteTreatmentResponse } from '../types/product.types';

const productService = {
  getProductTypes: (params: QueryParams) => request.get<PaginationData<ProductType>>(`/product-types`, { params }),
  findProductType: (productTypeId: number, params?: QueryParams) =>
    request.get<ProductType>(`/product-types/${productTypeId}`, { params }),
  createProductType: (data: object) => request.post('/product-types', data),
  updateProductType: (productTypeId: number, data: object) => request.put(`/product-types/${productTypeId}`, data),
  getProducts: (params: QueryParams) =>
    request.get<PaginationData<Product>>(`/products`, {
      params,
    }),
  getProductsByIds: (params: QueryParams) =>
    request.get<PaginationData<Product>>(`/products-by-ids`, {
      params,
    }),
  exportProducts: (productTypeId: string | number) => request.get(`/exports/products/${productTypeId}/export-to-excel`),
  excludeProducts: (productTypeId: number, data: { exclusion: boolean; ids: string[] }) =>
    request.put(`/products/exclude-products/${productTypeId}`, data),
  generateProduct: (productTypeId: string | number) => request.post(`/products/generate-products/${productTypeId}`),
  getProductTypesByRegionId: (regionId: number) => request.get<ProductType[]>(`/product-types-by-region/${regionId}`),
  getProductsByZoneIdForProductCatalogPrices: (zoneId: number, query: QueryParams) =>
    request.get<PaginationData<Product>>(`/products/products-by-zone-id/${zoneId}/product-catalog-prices`, {
      params: query,
    }),
  getProductsByZoneIdForProductCatalogOptionPrices: (zoneId: number, query: QueryParams) =>
    request.get<PaginationData<Product>>(`/products/products-by-zone-id/${zoneId}/product-catalog-option-prices`, {
      params: query,
    }),
  unVisibleProductType: (productTypeId: number) =>
    request.put<ProductType>(`/product-types-unvisible/${productTypeId}`),
  getProductTypeUnit: (params: QueryParams) =>
    request.get<PaginationData<ProductTypeUnit>>(`/product-type-units`, { params }),
  getProductTypeInterventions: (params: QueryParams) =>
    request.get<PaginationData<ProductTypeIntervention>>(`/product-type-interventions`, { params }),
  getInactiveProduct: () => request.get(`/products/inactive`),
  getFacturationType: (params: QueryParams) =>
    request.get<PaginationData<FacturationType>>(`/facturation-types`, { params }),
  getOneMultiProduct: (productId: number, params: QueryParams) =>
    request.get(`/products/multi-product/${productId}`, { params }),
  getMultiProduct: (params: QueryParams) => request.get(`/products-and-main-products`, { params }),
  getWasteTreaments: (productTypeId: number) =>
    request.get<WasteTreatmentResponse | null>(`/get-waste-treatment/${productTypeId}`),
  updateWasteTreatment: (productTypeId: number, data: { isWasteTreatment: boolean }) =>
    request.put(`/update-waste-treatment/${productTypeId}`, data),
  getProductTypesAsSameInterventions: (params: QueryParams) =>
    request.get<PaginationData<ProductType>>(`/product-types/get-all-types-as-same-intervention`, { params }),
  updateHiddenFromOrder: (productTypeId: number, data: { isHiddenFromOrder: boolean }) =>
    request.put(`/update-hidden-from-order/${productTypeId}`, data),
};

export default productService;
